import React from 'react';

type InputProps = {
  emailOverride?: string;
};

export const EmailSupportLink = ({ emailOverride }: InputProps) => {
  const supportEmail = emailOverride || 'support@teamengine.io';
  return (
    <a className="typo-link" href={`mailto: ${supportEmail}`}>
      {supportEmail}
    </a>
  );
};
